module.exports = __webpack_public_path__ + "static/media/Fowler_DKA.ca535998.jpeg";